/**
 * Type guard that checks if an array has at least one element.
 * Narrows the type from T[] to [T, ...T[]] (non-empty array).
 */
export function hasAtLeastOne<T>(arr: T[]): arr is [T, ...T[]] {
  return arr.length > 0
}
